import { useAppState, useAppDispatch } from '../../Shared/AppContext';

export function useUserMatchScoresState() {
  return useAppState();
}

export function useUserMatchScoresActions() {
  const dispatch = useAppDispatch();

  function initializeState(userId) {
    dispatch((appState) => ({
      ...appState,
      loading: true,
      userId: userId,
      pageNumber: 1,
      numberOfPages: 1,
      scores: [],
      totalCount: 0,
      sortBy: 'created_at',
      sortDirection: 'desc',
      gapFilter: 'all',
      createProspectModalIsOpen: false,
      createProspectScore: null,
      feedbackMessage: null,
      feedbackVariant: null,
    }));
  }

  function onResponse(response) {
    dispatch((appState) => ({ ...appState, ...response }));
  }

  function onError(feedback) {
    dispatch((appState) => ({ ...appState, ...feedback }));
  }

  function openCreateProspectModal(score) {
    dispatch((appState) => ({
      ...appState,
      createProspectModalIsOpen: true,
      createProspectScore: score,
    }));
  }

  function closeCreateProspectModal() {
    dispatch((appState) => ({
      ...appState,
      createProspectModalIsOpen: false,
      createProspectScore: null,
    }));
  }

  return {
    initializeState,
    onResponse,
    onError,
    openCreateProspectModal,
    closeCreateProspectModal,
  };
}
